import { render, staticRenderFns } from "./AttributeDetailDialog.vue?vue&type=template&id=10e2a353&scoped=true&"
import script from "./AttributeDetailDialog.vue?vue&type=script&lang=js&"
export * from "./AttributeDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./AttributeDetailDialog.vue?vue&type=style&index=0&id=10e2a353&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2a353",
  null
  
)

export default component.exports